
import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import Footer from '@/components/MainFooter';
import Hero from '@/components/automatic-sourcing/Hero';
import SuccessStoriesSection from '@/components/automatic-sourcing/SuccessStoriesSection';
import ProblemSection from '@/components/automatic-sourcing/ProblemSection';
import HowItWorks from '@/components/automatic-sourcing/HowItWorks';
import ProductVideo from './startup-offering/ProductVideo';
import SocialProofSection from '@/components/automatic-sourcing/SocialProofSection';
import TripleAdvantage from '@/components/TripleAdvantage';
import PricingSection from '@/components/automatic-sourcing/PricingSection';
import FAQ from '@/components/FAQ';
import FinalCTA from '@/components/automatic-sourcing/FinalCTA';

const AutomaticSourcing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Subscription Model | Cutshort</title>
        <meta name="description" content="High quality sourcing. Always on. Relevant candidates delivered continuously — without recruiters searching, screening, or switching tools." />
      </Helmet>

      <NavBar />
      
      <main className="flex-grow">
        <Hero />
        <SuccessStoriesSection />
        <TripleAdvantage />
        {/* <ProblemSection /> */}
        <HowItWorks />
        <ProductVideo />
        <PricingSection />
        <FAQ tags={["general", "automatic-sourcing"]} variant="automatic-sourcing" />
        <FinalCTA />
      </main>
      
      <Footer />
    </div>
  );
};

export default AutomaticSourcing;
